import Vuex from "vuex";

Vue.use(Vuex);

export const leverok_store = new Vuex.Store({
  state: {
    gameUrlPrefix: document.domain === 'localhost' || document.domain === 'ad-cagnotte.preprodrhinos.com' ? '/leverok' : '',
    gameState: 'welcome',
    source: false,
    qrcode: null,
    authenticated: false,
    hasValidatedTeeshirtChoice: false,
    teeshirt_sizes: ['S', 'M', 'L', 'XL'],
    clientInfo: {
      from_mail: null,
      cible: 'hors-mpa',
      card_number: null,
      code_client: null,
      ins_id: null,
      civ: 'mme',
      nom: null,
      prenom: null,
      adresse: null,
      zipcode: null,
      ville: null,
      email: null,
      mobile: null,
      teeshirt_size: 'S',
      preferred_magasin: null,
      entretien_vehicule: 'oui',
      type_reparation: [],
      achat_pieces: [],
      achat_pieces_internet: '',
      achat_pieces_magasin: '',
      achat_pieces_autre: '',
      rules: false,
      pub: false,
      //condition_achat: false,
      ticket_id: null,
      tickets_left: 0,
      has_confirmed_form: false,
      previous_gains: []
    },
    hasWheelSpun: false,
    // The order of this must be according to wheel clockwise
    prizesSlices: [
      { alias: "goodies", },
      { alias: "bon_achat", },
      { alias: "cadeaux_collectors", },
      { alias: "chance", },
    ],
    selectedGift: {
      name: '',
      alias: '',
      category: '',
      img_path: '',
      extra: null
    },
    highlighted_gifts: [],
    magasins: []
  },
  getters: {
    isClientAuthenticated: state => state.authenticated,
    getGameUrlPrefix: state => state.gameUrlPrefix,
    getMainFormPath: state => {
      if (state.source === "flashcode") {
        return state.gameUrlPrefix + `/${state.source}/${state.qrcode}`
      }

      return state.gameUrlPrefix + `/${state.source}` //${state.clientInfo.card_number ? '/' + state.clientInfo.card_number : ''}
    },
    getFromSource: state => state.source,
    getQrCode: state => state.qrcode,
    getClientInfo: state => state.clientInfo,
    hasValidatedTeeshirtChoice: state => state.hasValidatedTeeshirtChoice,
    getGameState: state => state.gameState,
    getTicketsLeft: state => state.clientInfo.tickets_left,
    renderGains: state =>
      [... new Set(state.clientInfo.previous_gains.map(pg => pg.name))]
        .map(gn => state.clientInfo.previous_gains.find(pg => pg.name === gn))
        .map(gain => gain.qte + ' <span class="font-weight-bold text-uppercase">' + gain.name + '</span>')
        .join(', '),
    isFromMail: state => state.clientInfo.from_mail,
    hasWheelSpun: state => state.hasWheelSpun,
    getSelectedGift: state => state.selectedGift,
    getGiftImgPath: state => {
      try {
        return state.selectedGift.img_path ? require('../../../../images/game/gains/' + state.selectedGift.img_path) : ''
      } catch (error) {
        return '';
      }
    },
    getPrizesSlices: state => state.prizesSlices,
    getHighlightedGifts: state => state.highlighted_gifts,
    getMagasins: state => state.magasins,
    getTeeShirtSizes: state => state.teeshirt_sizes,
    getRegistrationData: state => {
      return {
        civ: state.clientInfo.civ,
        nom: state.clientInfo.nom,
        prenom: state.clientInfo.prenom,
        adresse: state.clientInfo.adresse,
        zipcode: state.clientInfo.zipcode,
        ville: state.clientInfo.ville,
        email: state.clientInfo.email,
        mobile: state.clientInfo.mobile,
        teeshirt_size: state.clientInfo.teeshirt_size,
        entretien_vehicule: state.clientInfo.entretien_vehicule,
        ...(state.clientInfo.entretien_vehicule === 'oui' && { type_reparation: state.clientInfo.type_reparation }),
        achat_pieces: state.clientInfo.achat_pieces,
        ...(state.clientInfo.achat_pieces.includes('internet') && { achat_pieces_internet: state.clientInfo.achat_pieces_internet }),
        ...(state.clientInfo.achat_pieces.includes('magasin') && { achat_pieces_magasin: state.clientInfo.achat_pieces_magasin }),
        ...(state.clientInfo.achat_pieces.includes('autre') && { achat_pieces_autre: state.clientInfo.achat_pieces_autre }),
        source: state.source,
        pub: state.clientInfo.pub,
      };
    },
    getCurrentSuperLot: () => {
      const date = new Date();

      if (date < new Date(2024, 5, 17)) {
        return { date: '14/07/2024', img_name: 'plancha' }
      } /*else if (date >= new Date(2024, 2, 15) && date < new Date(2024, 2, 29)) {
                return { date: '29/03/2024', img_name: 'relais_chateaux' }
            } else if (date >= new Date(2024, 2, 29) && date < new Date(2024, 3, 12)) {
                return { date: '12/04/2024', img_name: 'playstation' }
            } else if (date >= new Date(2024, 3, 12)) {
                return { date: '02/05/2024', img_name: 'televiseur' }
            }*/ else { // fallback
        return { date: '14/07/2024', img_name: 'plancha' }
      }
    }
  },
  actions: {
    scrollToTop: () => window.scroll({ top: 0, left: 0, behavior: 'smooth' }),
    fillLoginForm: ({ state, commit }, card_number) => {
      axios.get(state.gameUrlPrefix + "/client-login-info/" + card_number)
        .then(res => commit('UPDATE_CLIENT_INFO', { ...res.data, card_number, from_mail: true }))
    },
    fetchClientDetails: ({ state }, payload) => {
      return new Promise((resolve, reject) => {
        axios.get(state.gameUrlPrefix + "/client-details", { params: { ...payload, source: state.source } })
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      })
    },
    fetchPreviousGiftsDetails: ({ state }) => {
      return new Promise((resolve, reject) => {
        axios.get(state.gameUrlPrefix + "/previous-gifts-details", { params: { card_number: state.clientInfo.card_number, ins_id: state.clientInfo.ins_id } })
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      })
    },
    fetchGift: ({ state }) => {
      return new Promise((resolve, reject) => {
        axios.get(state.gameUrlPrefix + "/gift", { params: { ticket_id: state.clientInfo.ticket_id, card_number: state.clientInfo.card_number, ins_id: state.clientInfo.ins_id, preferred_magasin: state.clientInfo.preferred_magasin } })
          .then(res => resolve(res.data), error => reject(error))
      })
    },
    replayWheel: ({ state }) => {
      return new Promise((resolve, reject) => {
        axios.get(state.gameUrlPrefix + "/replay-wheel", { params: { card_number: state.clientInfo.card_number, ins_id: state.clientInfo.ins_id } })
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      })
    },
    saveTeeshirtSize: ({ state }, payload) => {
      return new Promise((resolve, reject) => {
        axios.post(state.gameUrlPrefix + "/save-teeshirt-size", { ...payload, ticket_id: state.clientInfo.ticket_id, preferred_magasin: state.clientInfo.preferred_magasin })
          .then(res => resolve(res.data), error => resolve(error))
          .catch(error => reject(error))
      });
    },
    fetchMagasins: ({ state }) => {
      return new Promise((resolve, reject) => {
        axios.get(state.gameUrlPrefix + "/magasins", { params: { card_number: state.clientInfo.card_number } })
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      });
    },
    setClientDetails: ({ state }, payload) => {
      return new Promise((resolve, reject) => {
        axios.post(state.gameUrlPrefix + "/client-details", {
          ...payload,
          card_number: state.clientInfo.card_number,
          email: state.clientInfo.email,
          mobile: state.clientInfo.mobile,
        })
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      });
    },
    registerEntry: ({ state }, payload) => {
      return new Promise((resolve, reject) => {
        axios.post(state.gameUrlPrefix + "/register", {
          ...payload,
        })
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      });
    },
    fetchHighlightedGifts: ({ state }) => {
      return new Promise((resolve, reject) => {
        axios.get(state.gameUrlPrefix + "/highlighted-gifts")
          .then(res => resolve(res.data), error => reject(error))
          .catch(error => reject(error))
      });
    }
  },
  mutations: {
    SET_AUTHENTICATED(state, source) {
      state.authenticated = source;
    },
    UPDATE_SOURCE(state, source) {
      state.source = source;
    },
    UPDATE_QR_CODE(state, qrcode) {
      state.qrcode = qrcode;
    },
    UPDATE_GAME_STATE(state, gameState) {
      state.gameState = gameState;
    },
    UPDATE_CLIENT_INFO(state, payload) {
      state.clientInfo = { ...state.clientInfo, ...payload };
    },
    UPDATE_GIFT_INFO(state, payload) {
      state.selectedGift = { ...state.selectedGift, ...payload };
    },
    UPDATE_TEESHIRT_CHOICE(state, bool) {
      state.hasValidatedTeeshirtChoice = bool;
    },
    UPDATE_HIGHLIGHTED_GIFTS(state, payload) {
      state.highlighted_gifts = payload;
    },
    UPDATE_MAGASINS(state, payload) {
      state.magasins = payload;
    },
    UPDATE_WHEEL_HAS_SPUN(state, wheelSpinState) {
      state.hasWheelSpun = wheelSpinState;
    },
    ADD_NB_TICKET(state, qte) {
      state.clientInfo.tickets_left = state.clientInfo.tickets_left + qte;
    },
    UPDATE_NB_TICKET(state, qte) {
      state.clientInfo.tickets_left = qte;
    },
  },
});
